import { render } from "./mvt-articlegrid.vue?vue&type=template&id=34326ede"
import script from "./mvt-articlegrid.js?vue&type=script&lang=js"
export * from "./mvt-articlegrid.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__